import { render, staticRenderFns } from "./PendingLoanPaymentApprovals.vue?vue&type=template&id=3940ef1a&"
import script from "./PendingLoanPaymentApprovals.vue?vue&type=script&lang=js&"
export * from "./PendingLoanPaymentApprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports